(function() {
  'use strict';

  function initTestimonial(root) {
    if (root.dataset.initialized === '1') return;
    root.dataset.initialized = '1';

    var track = root.querySelector('.dr-testimonial__track');
    var slides = Array.from(track.querySelectorAll('.dr-testimonial__slide'));
    var cursor = root.querySelector('.dr-testimonial__cursor');
    if (!track) return;
    var readMoreLabel = root.dataset.readMoreLabel || 'קראי עוד';
    var readLessLabel = root.dataset.readLessLabel || 'קראי פחות';

    function getCollapsedHeightPx() {
      var cssValue = window.getComputedStyle(root).getPropertyValue('--dr-testimonial-collapsed-height');
      var parsed = parseFloat(cssValue);
      return Number.isFinite(parsed) ? parsed : 120;
    }

    var quoteItems = slides.map(function(slide) {
      var quoteContent = slide.querySelector('[data-testimonial-quote-content]');
      var button = slide.querySelector('.dr-testimonial__read-toggle');
      if (!quoteContent || !button) return null;

      var item = {
        slide: slide,
        quoteContent: quoteContent,
        button: button,
        expanded: false,
        collapse: function() {
          if (!this.expanded) return;
          this.expanded = false;
          this.quoteContent.classList.remove('is-expanded');
          this.quoteContent.style.removeProperty('--dr-testimonial-expanded-height');
          this.button.textContent = readMoreLabel;
          this.button.setAttribute('aria-expanded', 'false');
        }
      };

      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (item.expanded) {
          item.collapse();
          return;
        }

        item.expanded = true;
        item.quoteContent.classList.add('is-expanded');
        item.quoteContent.style.setProperty('--dr-testimonial-expanded-height', item.quoteContent.scrollHeight + 'px');
        item.button.textContent = readLessLabel;
        item.button.setAttribute('aria-expanded', 'true');
      });

      return item;
    }).filter(Boolean);

    // Auto-collapse expanded quotes when they scroll out of view (wait for snap to settle)
    if (quoteItems.length > 0) {
      var supportsScrollEnd = 'onscrollend' in window;

      function handleScrollSettle() {
        var currentIndex = getCurrentSlideIndex();
        var currentSlide = slides[currentIndex];
        
        quoteItems.forEach(function(item) {
          if (item.expanded && item.slide !== currentSlide) {
            item.collapse();
          }
        });
      }

      if (supportsScrollEnd) {
        // Modern, bulletproof method (iOS 16.4+). Fires only when momentum/snapping is 100% finished.
        track.addEventListener('scrollend', handleScrollSettle);
      } else {
        // Fallback for older devices
        var collapseTimeout;
        track.addEventListener('scroll', function() {
          window.clearTimeout(collapseTimeout);
          collapseTimeout = window.setTimeout(handleScrollSettle, 250);
        }, { passive: true });
      }
    }

    function recalcQuotes() {
      if (!quoteItems.length) return;
      var collapsedHeight = getCollapsedHeightPx();

      quoteItems.forEach(function(item) {
        var wasExpanded = item.expanded;

        item.quoteContent.classList.remove('is-expanded');
        item.quoteContent.style.removeProperty('--dr-testimonial-expanded-height');
        var fullHeight = item.quoteContent.scrollHeight;
        var isOverflowing = fullHeight > collapsedHeight + 5;

        if (!isOverflowing) {
          item.expanded = false;
          item.button.hidden = true;
          item.button.textContent = readMoreLabel;
          item.button.setAttribute('aria-expanded', 'false');
          return;
        }

        item.button.hidden = false;
        if (wasExpanded) {
          item.expanded = true;
          item.quoteContent.classList.add('is-expanded');
          item.quoteContent.style.setProperty('--dr-testimonial-expanded-height', fullHeight + 'px');
          item.button.textContent = readLessLabel;
          item.button.setAttribute('aria-expanded', 'true');
          return;
        }

        item.collapse();
      });
    }

    function debounce(fn, wait) {
      var timerId;
      return function() {
        window.clearTimeout(timerId);
        timerId = window.setTimeout(fn, wait);
      };
    }

    // --- Drag to Scroll & Custom Cursor Logic ---
    var isDown = false;
    var hasMouseDragged = false;
    var startX;
    var scrollLeft;

    // Only apply helper cursor on devices with real hover + fine pointer.
    var hasCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || hasCoarsePointer;
    var canUseHoverCursor = window.matchMedia
      ? window.matchMedia('(hover: hover) and (pointer: fine)').matches
      : !isTouchDevice;
    root.classList.toggle('dr-testimonial--non-touch', canUseHoverCursor);
    var tapStartX = 0;
    var tapStartY = 0;
    var tapMoved = false;
    var suppressClickUntil = 0;
    var TAP_MOVE_THRESHOLD = 10;
    var DRAG_MOVE_THRESHOLD = 6;

    function getTrackCenterX() {
      var rect = track.getBoundingClientRect();
      return rect.left + (rect.width / 2);
    }

    function getCurrentSlideIndex() {
      if (!slides.length) return 0;

      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + (trackRect.width / 2);
      var bestVisibleIndex = -1;
      var bestVisibleWidth = -1;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function(slide, index) {
        var rect = slide.getBoundingClientRect();
        var visibleLeft = Math.max(rect.left, trackRect.left);
        var visibleRight = Math.min(rect.right, trackRect.right);
        var visibleWidth = Math.max(0, visibleRight - visibleLeft);

        // Prefer the slide with the largest visible area.
        // This makes edge slides resolve correctly even when not perfectly centered.
        if (visibleWidth > bestVisibleWidth) {
          bestVisibleWidth = visibleWidth;
          bestVisibleIndex = index;
        }

        var slideCenter = rect.left + (rect.width / 2);
        var distance = Math.abs(slideCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return bestVisibleIndex > -1 ? bestVisibleIndex : closestIndex;
    }

    function goToIndex(index) {
      if (!slides.length) return;

      var safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      var target = slides[safeIndex];

      // Prefer browser-native centering to avoid RTL scrollLeft inconsistencies.
      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        return;
      }

      // Fallback: delta-based scroll for older environments.
      var trackCenter = getTrackCenterX();
      var targetRect = target.getBoundingClientRect();
      var targetCenter = targetRect.left + (targetRect.width / 2);
      var delta = targetCenter - trackCenter;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    function goByDelta(delta) {
      if (slides.length < 2) return;

      var currentIndex = getCurrentSlideIndex();
      var nextIndex = (currentIndex + delta) % slides.length;
      if (nextIndex < 0) nextIndex += slides.length;

      goToIndex(nextIndex);
    }

    function isInteractiveTarget(target) {
      if (!target || !target.closest) return false;
      return Boolean(target.closest('a, button, input, textarea, select, label, summary, [data-no-tap-nav]'));
    }

    function handleTapNavigation(clientX, target) {
      if (slides.length < 2) return;
      if (isInteractiveTarget(target)) return;

      var rect = track.getBoundingClientRect();
      var middle = rect.left + (rect.width / 2);

      // Reversed tap direction: left half -> next, right half -> previous.
      if (clientX >= middle) {
        goByDelta(-1);
      } else {
        goByDelta(1);
      }
    }

    if (canUseHoverCursor) {
      track.addEventListener('mousedown', function(e) {
        if (isInteractiveTarget(e.target)) return;
        isDown = true;
        hasMouseDragged = false;
        track.classList.add('is-dragging');
        if (cursor) cursor.classList.add('is-dragging');
        
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        
        // Prevent text selection while dragging
        e.preventDefault();
      });

      track.addEventListener('mouseleave', function() {
        isDown = false;
        track.classList.remove('is-dragging');
        if (cursor) {
          cursor.classList.remove('is-dragging');
          cursor.classList.remove('is-visible');
        }
      });

      track.addEventListener('mouseup', function() {
        isDown = false;
        track.classList.remove('is-dragging');
        if (cursor) cursor.classList.remove('is-dragging');
      });

      track.addEventListener('mousemove', function(e) {
        // Update custom cursor position
        if (cursor) {
          cursor.style.left = e.clientX + 'px';
          cursor.style.top = e.clientY + 'px';
          
          if (isInteractiveTarget(e.target)) {
            cursor.classList.remove('is-visible');
          } else if (!isDown) {
            cursor.classList.add('is-visible');
          }
        }

        if (!isDown) return;
        e.preventDefault();
        
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5; // Scroll speed multiplier
        if (Math.abs(x - startX) > DRAG_MOVE_THRESHOLD) {
          hasMouseDragged = true;
        }
        
        // In RTL, scrollLeft behaves differently across browsers.
        // We subtract walk so drag direction feels natural.
        track.scrollLeft = scrollLeft - walk;
      });

      track.addEventListener('mouseenter', function() {
        if (cursor) cursor.classList.add('is-visible');
      });
    }

    // Tap navigation (additive): left/right tap swaps testimonials.
    if (!canUseHoverCursor) {
      track.addEventListener('touchstart', function(e) {
        if (!e.touches || !e.touches.length) return;
        if (cursor) {
          cursor.classList.remove('is-visible');
          cursor.classList.remove('is-dragging');
        }
        tapStartX = e.touches[0].clientX;
        tapStartY = e.touches[0].clientY;
        tapMoved = false;
      }, { passive: true });

      track.addEventListener('touchmove', function(e) {
        if (!e.touches || !e.touches.length) return;
        var dx = Math.abs(e.touches[0].clientX - tapStartX);
        var dy = Math.abs(e.touches[0].clientY - tapStartY);
        if (dx > TAP_MOVE_THRESHOLD || dy > TAP_MOVE_THRESHOLD) {
          tapMoved = true;
        }
      }, { passive: true });

      track.addEventListener('touchend', function(e) {
        if (!e.changedTouches || !e.changedTouches.length) return;
        if (!tapMoved) {
          handleTapNavigation(e.changedTouches[0].clientX, e.target);
        }
        suppressClickUntil = Date.now() + 450;
      }, { passive: true });
    }

    track.addEventListener('click', function(e) {
      if (Date.now() < suppressClickUntil) return;
      if (hasMouseDragged) {
        hasMouseDragged = false;
        return;
      }
      handleTapNavigation(e.clientX, e.target);
    });

    recalcQuotes();
    var recalcQuotesDebounced = debounce(recalcQuotes, 120);
    window.addEventListener('resize', recalcQuotesDebounced);

    // Vee changes the root resize class without necessarily firing a window
    // resize event. Re-measure after each level change so the read-more control
    // reflects the quote's new wrapped height.
    if (window.MutationObserver) {
      var lastVeeResizeClass = Array.from(document.documentElement.classList)
        .filter(function(className) { return className.indexOf('vp_filter_resize_font_') === 0; })
        .join(' ');
      var veeResizeObserver = new MutationObserver(function() {
        var nextVeeResizeClass = Array.from(document.documentElement.classList)
          .filter(function(className) { return className.indexOf('vp_filter_resize_font_') === 0; })
          .join(' ');
        if (nextVeeResizeClass === lastVeeResizeClass) return;
        lastVeeResizeClass = nextVeeResizeClass;
        recalcQuotesDebounced();
      });
      veeResizeObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        recalcQuotes();
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.dr-testimonial');
    roots.forEach(initTestimonial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelectorAll) {
      var roots = e.target.querySelectorAll('.dr-testimonial');
      roots.forEach(initTestimonial);
    }
  });
})();
